import { optionSubcategory_calMultiAccounts } from './accountsSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import AccountsOption from 'owa-calendar-accounts-option/lib/AccountsOption';
import initOWAAccount from 'owa-calendar-accounts-option/lib/orchestration/initOWAAccountsConfiguration';

const accountsSubCategory: OptionSubCategory = {
    key: 'calAccounts',
    titleStringKey: optionSubcategory_calMultiAccounts,
    options: [AccountsOption],
    onSelected: initOWAAccount,
};

export default accountsSubCategory;
